import client from './client'

export default {
  async getUserInfo (uid) {
    const url = `/users/${uid}`
    const res = await client.get(url)
    return res && res.data && res.data.data
  },
  authorMsg (uid) {
    return client.get(`/author/user/${uid}`)
  },
  /**
   * 获取视频
   * @param uid
   * @param isVertical 0横版 1竖版
   * @param page
   * @param limit
   * @returns {*}
   */
  authorVideos (uid, isVertical = 0, page = 1, limit = 10) {
    return client.get(`/authors/${uid}/videos`, { params: { page, limit, isVertical } })
  },
  getUser () {
    return client.get(`/user/info`)
  },
  jinceUser () {
    return client.get(`/verify/jinceUser`)
  }
}



// WEBPACK FOOTER //
// ./src/apis/ultron-api/user.js